<div
  [style.width.px]="columnWidth"
  class="relative flex w-fit flex-col items-center justify-center">
  @if (!tableData.confirmed() || this.tableData.columnHeaders()[this.columnIndex]) {
    <p-menu
      data-testid="table-overlay-column-assignment-menu"
      floatingElement
      [dt]="{ background: 'rgba(255, 255, 255, 0.75)' }"
      [isOpened]="isMenuOpened()"
      [offsetConfig]="{ main: 10 }"
      [anchor]="label"
      [placement]="'top'"
      (mousedown)="$event.stopPropagation()"
      (outsideClick)="isMenuOpened.set(false)"
      [model]="menuItems()"
      class="pointer-events-auto absolute z-50"
      [attr.data-col-index]="columnIndex"
      [ngClass]="isMenuOpened() ? 'visible' : 'invisible'" />
    <button
      class="pointer-events-auto relative flex flex-col items-center justify-center rounded-xl"
      [ngClass]="
        !isMenuOpened()
          ? this.tableData.columnHeaders()[this.columnIndex] === NOT_IMPORTANT_TABLE_HEADER
            ? 'bg-theme-gray-600 text-white'
            : 'bg-theme-dark-blue text-white'
          : 'border-theme-dark-blue text-theme-dark-blue border bg-[#E9F4F8]'
      "
      (mousedown)="$event.stopPropagation()"
      (click)="columnButtonClicked.emit(columnIndex); $event.stopPropagation()">
      <div
        #label
        style="writing-mode: vertical-rl"
        class="-rotate-180"
        [ngClass]="{ 'leading-[0]': !this.tableData.columnHeaders()[this.columnIndex] }">
        @if (this.tableData.columnHeaders()[this.columnIndex]; as header) {
          <span class="block px-1.5 py-1.5 text-xs">
            {{ tableColumnLabelsByKeys()[header] ?? 'Unwichtig' }}
          </span>
        } @else {
          <span class="material-icons">add</span>
        }
      </div>
    </button>
  }
</div>
